/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useRef } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";

const model = "/models/desk/mouse.glb";

export default function Mouse({ ...props }) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF(model);
  const { actions } = useAnimations(animations, group);

  useEffect(() => {
    actions.move_mouse.play();
  }, []);

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group
          name="armature_mouse"
          position={[-2.57, 1.05, 2.46]}
          rotation={[Math.PI / 2, 0, -0.24]}
        >
          <group name="Bone" position={[0, -0.09, 0]}>
            <group
              name="mouse"
              position={[0, 0.11, 0]}
              rotation={[-Math.PI / 2, 0, 0]}
            >
              <mesh
                name="Cube001"
                geometry={nodes.Cube001.geometry}
                material={materials["black mate.001"]}
              />
              <mesh
                name="Cube001_1"
                geometry={nodes.Cube001_1.geometry}
                material={materials["gray mate"]}
              />
            </group>
          </group>
        </group>
        <mesh
          name="mat"
          geometry={nodes.mat.geometry}
          material={materials["black mate"]}
          position={[-2.74, 1.02, 2.52]}
        />
      </group>
    </group>
  );
}

useGLTF.preload(model);
